import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../../contexts/CartContext';
import { Link } from 'react-router-dom';

const CartIcon = () => {
  const { state } = useCart();
  const itemCount = state.items.reduce((acc, item) => acc + item.quantity, 0);

  return (
    <Link to="/cart" className="relative">
      <ShoppingCart className="text-gray-700 hover:text-[#9a6ebd] transition-colors" size={24} />
      {itemCount > 0 && (
        <span className="absolute -top-2 -right-2 bg-[#9a6ebd] text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
          {itemCount}
        </span>
      )}
    </Link>
  );
};

export default CartIcon;